<template>
  <div v-if="breadcrumbs.length > 0" class="breadcrumbs text-sm">
    <ul>
      <li v-for="breadcrumb in breadcrumbs" :key="`breadcrumb-${breadcrumb.name}`">
        <router-link v-if="breadcrumb.to" :to="breadcrumb.to">{{ breadcrumb.name }}</router-link>
        <span v-else>{{ breadcrumb.name }}</span>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  computed: {
    breadcrumbs() {
      return this.$store.state.general.breadcrumbs || [];
    },
  },
};
</script>
